<template lang="pug">
  div.mb-3.mb-sm-4(v-show="show", style="padding:56.25% 0 0 0;position:relative;")
    iframe.video(:src="currentStep.video" :onload="onLoaded(this)", style="position:absolute;top:0;left:0;width:100%;height:100%;", frameborder="0")
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'VideoPlay',
  computed: {
      ...mapGetters(['currentStep'])
  },
  data() {
    return {
      show:false
    }
  },
  methods: {
    onLoaded() {
      this.show = true;
    }
  },
}
</script>

<style scoped>
@import 'video.scss';
</style>

